import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultUnifiedHelpTitle: {
        defaultMessage: 'Unified Help',
        description: 'Default Unified Help pages title',
        id: 'help-center.unified.help.title.default',
    },
});
